(function () {
  if (window.MVPRegistration && window.MVPRegistration.loaded) return;

  window.MVPRegistration = { loaded: true };

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function getAgeFromDob(value) {
    if (!value) return null;

    const dob = new Date(value);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age -= 1;
    }

    return age;
  }

  function initParticipationTermsModal() {
    const modal = document.getElementById('mvp-participation-terms-modal');
    if (!modal) return;

    const dialog = modal.querySelector('.mvp-participation-terms-modal__dialog');
    const openButtons = document.querySelectorAll('[data-mvp-participation-terms-open]');
    const closeButtons = modal.querySelectorAll('[data-mvp-participation-terms-close]');
    let lastFocusedElement = null;

    function openModal(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      lastFocusedElement = document.activeElement;
      modal.hidden = false;

      if (dialog) {
        dialog.focus();
      }
    }

    function closeModal() {
      modal.hidden = true;

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', openModal);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  function initU18Registration() {
    const previousCheckbox = document.getElementById('mvp-registration-previously-completed');
    const registrationFields = document.getElementById('mvp-registration-fields');
    const existingVerification = document.getElementById('mvp-existing-player-verification');
    const registrationStatus = document.getElementById('mvp-registration-status');
    const dobField = document.getElementById('mvp-player-dob');
    const existingDobField = document.getElementById('mvp-existing-player-dob');
    const parentGuardianFields = document.getElementById('mvp-parent-guardian-fields');
    const under18TermsLabel = document.querySelector('[data-mvp-u18-under-18-terms-label]');
    const under18PhotoLabel = document.querySelector('[data-mvp-u18-under-18-photo-label]');
    const ageWarning = document.getElementById('mvp-u18-age-warning');
    const existingAgeWarning = document.getElementById('mvp-u18-existing-age-warning');
    const medicalSelect = document.getElementById('mvp-medical');
    const medicalDetailsWrap = document.getElementById('mvp-medical-details-wrap');
    const medicalDetails = document.getElementById('mvp-medical-details');

    if (!previousCheckbox || !registrationFields || !existingVerification || !registrationStatus) return;

    const fullFormFields = registrationFields.querySelectorAll('input, select, textarea');
    const verificationFields = existingVerification.querySelectorAll('input, select, textarea');
    const parentGuardianInputs = parentGuardianFields ? parentGuardianFields.querySelectorAll('input, select, textarea') : [];

    fullFormFields.forEach(function (field) {
      field.dataset.mvpOriginalDisabled = field.disabled ? 'true' : 'false';
      field.dataset.mvpOriginalRequired = field.required ? 'true' : 'false';
    });

    function setFieldsState(fields, enabled) {
      fields.forEach(function (field) {
        if (enabled) {
          field.disabled = false;
          field.required = true;
        } else {
          field.disabled = true;
          field.required = false;
          field.value = '';
        }
      });
    }

    function toggleAgeBasedFields() {
      if (!dobField || !parentGuardianFields) return;

      const activeDobField = previousCheckbox.checked && existingDobField ? existingDobField : dobField;
      const inactiveDobField = previousCheckbox.checked ? dobField : existingDobField;
      const age = getAgeFromDob(activeDobField.value);
      const isUnder18 = age !== null && age < 18;
      const isTooOldForU18 = age !== null && age >= 18;
      const shouldEnableAgeFields = !previousCheckbox.checked;

      parentGuardianFields.hidden = !isUnder18;
      setFieldsState(parentGuardianInputs, shouldEnableAgeFields && isUnder18);

      if (ageWarning) ageWarning.hidden = previousCheckbox.checked || !isTooOldForU18;
      if (existingAgeWarning) existingAgeWarning.hidden = !previousCheckbox.checked || !isTooOldForU18;
      if (under18TermsLabel) under18TermsLabel.hidden = false;
      if (under18PhotoLabel) under18PhotoLabel.hidden = false;

      if (isTooOldForU18) {
        activeDobField.setCustomValidity('This U18 program is only available for players aged 17 and under.');
      } else {
        activeDobField.setCustomValidity('');
      }

      if (inactiveDobField) inactiveDobField.setCustomValidity('');
    }

    function toggleMedicalDetails() {
      if (!medicalSelect || !medicalDetailsWrap || !medicalDetails) return;

      const showDetails = medicalSelect.value === 'Yes';
      medicalDetailsWrap.hidden = !showDetails;
      medicalDetails.disabled = !showDetails;
      medicalDetails.required = showDetails;

      if (!showDetails) {
        medicalDetails.value = '';
      }
    }

    function toggleRegistrationForm() {
      if (previousCheckbox.checked) {
        registrationFields.style.display = 'none';
        existingVerification.style.display = 'block';
        registrationStatus.value = 'Previously completed registration form - verification provided';

        fullFormFields.forEach(function (field) {
          field.disabled = true;
          field.required = false;
        });

        setFieldsState(verificationFields, true);
        toggleAgeBasedFields();
      } else {
        registrationFields.style.display = 'block';
        existingVerification.style.display = 'none';
        registrationStatus.value = 'New registration form completed';

        fullFormFields.forEach(function (field) {
          field.disabled = field.dataset.mvpOriginalDisabled === 'true';
          field.required = field.dataset.mvpOriginalRequired === 'true';
        });

        setFieldsState(verificationFields, false);
        toggleAgeBasedFields();

        const experienceSelect = document.getElementById('mvp-volleyball-experience');
        if (experienceSelect) {
          experienceSelect.dispatchEvent(new Event('change'));
        }

        toggleMedicalDetails();
      }
    }

    if (dobField) dobField.addEventListener('change', toggleAgeBasedFields);
    if (existingDobField) existingDobField.addEventListener('change', toggleAgeBasedFields);
    if (medicalSelect) medicalSelect.addEventListener('change', toggleMedicalDetails);
    previousCheckbox.addEventListener('change', toggleRegistrationForm);
    toggleRegistrationForm();
  }

  function initExperienceOtherField() {
    const experienceSelect = document.getElementById('mvp-volleyball-experience');
    const otherWrapper = document.getElementById('mvp-volleyball-experience-other-wrapper');
    const otherField = document.getElementById('mvp-volleyball-experience-other');

    if (!experienceSelect || !otherWrapper || !otherField) return;

    function toggleOtherField() {
      if (experienceSelect.value === 'Other') {
        otherWrapper.style.display = 'block';
        otherField.disabled = false;
      } else {
        otherWrapper.style.display = 'none';
        otherField.value = '';
        otherField.disabled = true;
      }
    }

    experienceSelect.addEventListener('change', toggleOtherField);
    toggleOtherField();
  }

  function initAustralianPhoneFields() {
    const australianPhoneFields = document.querySelectorAll('[data-mvp-aus-phone]');

    australianPhoneFields.forEach(function (field) {
      field.addEventListener('input', function () {
        field.value = field.value.replace(/\D/g, '').slice(0, 10);
      });
    });
  }

  function initSettingPassingClinicRegistration() {
    const registrationStatus = document.getElementById('mvp-setting-passing-clinic-registration-status');
    const dobField = document.getElementById('mvp-setting-passing-clinic-dob');
    const previousRegistrationInputs = document.querySelectorAll('input[name="properties[Previously Completed Registration Form]"]');
    const adultTermsLabel = document.querySelector('[data-mvp-clinic-adult-terms-label]');
    const under18TermsLabel = document.querySelector('[data-mvp-clinic-under-18-terms-label]');

    if (!registrationStatus || !dobField || !previousRegistrationInputs.length) return;

    function syncAgeLabels() {
      const dobValue = dobField.value;
      const age = getAgeFromDob(dobValue);
      const isUnder18 = age !== null && age < 18;

      if (adultTermsLabel) adultTermsLabel.hidden = isUnder18;
      if (under18TermsLabel) under18TermsLabel.hidden = !isUnder18;
    }

    function syncRegistrationStatus() {
      const selectedPreviousRegistration = document.querySelector('input[name="properties[Previously Completed Registration Form]"]:checked');

      if (selectedPreviousRegistration && selectedPreviousRegistration.value === 'Yes') {
        registrationStatus.value = 'Previously completed Training Player Registration Form - details unchanged';
      } else if (selectedPreviousRegistration && selectedPreviousRegistration.value === 'No') {
        registrationStatus.value = 'Training Player Registration Form required after purchase';
      } else {
        registrationStatus.value = 'Training registration summary provided on order';
      }
    }

    dobField.addEventListener('change', syncAgeLabels);
    previousRegistrationInputs.forEach(function (input) {
      input.addEventListener('change', syncRegistrationStatus);
    });

    syncAgeLabels();
    syncRegistrationStatus();
  }

  function initSocialsRegistration() {
    const registrations = document.querySelectorAll('[data-mvp-socials-registration]');

    registrations.forEach(function (registration) {
      const formId = registration.dataset.productFormId;
      const productForm = document.getElementById(formId);
      const quantityInput = document.querySelector('[name="quantity"][form="' + formId + '"]') || (productForm ? productForm.querySelector('[name="quantity"]') : null);
      const isTeamTicket = registration.dataset.mvpSocialsTeamTicket === 'true';
      const teamCountInput = registration.querySelector('[data-mvp-socials-team-count]');
      const playersContainer = registration.querySelector('[data-mvp-socials-players]');
      const adultPath = registration.querySelector('[data-mvp-socials-adult-path]');
      const juniorPath = registration.querySelector('[data-mvp-socials-junior-path]');
      const ageInputs = registration.querySelectorAll('input[name="properties[Any Participants Under 18]"]');
      const errorMessage = registration.querySelector('[data-mvp-socials-error]');

      function getParticipantCount() {
        if (isTeamTicket) {
          const rawTeamCount = teamCountInput ? parseInt(teamCountInput.value, 10) : 0;
          return Number.isFinite(rawTeamCount) && rawTeamCount > 0 ? Math.min(rawTeamCount, 15) : 0;
        }

        const rawQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        return Number.isFinite(rawQuantity) && rawQuantity > 0 ? rawQuantity : 1;
      }

      function createPlayerField(index) {
        const field = document.createElement('div');
        field.className = 'mvp-socials-registration__field';
        field.dataset.mvpSocialsPlayerField = String(index);
        field.innerHTML =
          '<label class="mvp-socials-registration__label" for="mvp-socials-player-' + formId + '-' + index + '">' +
            'Player ' + index + ' Full Name' +
          '</label>' +
          '<input ' +
            'class="mvp-socials-registration__input" ' +
            'id="mvp-socials-player-' + formId + '-' + index + '" ' +
            'type="text" ' +
            'name="properties[Player ' + index + ' Full Name]" ' +
            'form="' + formId + '" ' +
            'autocomplete="name" ' +
            'required' +
          '>';
        return field;
      }

      function syncPlayerFields() {
        const participantCount = getParticipantCount();
        const existingFields = playersContainer.querySelectorAll('[data-mvp-socials-player-field]');

        existingFields.forEach(function (field) {
          const index = parseInt(field.dataset.mvpSocialsPlayerField, 10);
          if (index > participantCount) {
            field.remove();
          }
        });

        for (let index = 1; index <= participantCount; index += 1) {
          if (!playersContainer.querySelector('[data-mvp-socials-player-field="' + index + '"]')) {
            playersContainer.appendChild(createPlayerField(index));
          }
        }
      }

      function setPathState(path, isActive) {
        const fields = path.querySelectorAll('input');
        path.hidden = !isActive;

        fields.forEach(function (field) {
          field.disabled = !isActive;
          field.required = isActive;

          if (!isActive) {
            field.checked = false;
          }
        });
      }

      function syncConditionalFields() {
        const selectedAgeValue = registration.querySelector('input[name="properties[Any Participants Under 18]"]:checked')?.value;
        setPathState(adultPath, selectedAgeValue === 'No');
        setPathState(juniorPath, selectedAgeValue === 'Yes');
      }

      function showError() {
        errorMessage.classList.add('is-visible');
        registration.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      function hideError() {
        errorMessage.classList.remove('is-visible');
      }

      function validateRegistration(event) {
        syncPlayerFields();
        syncConditionalFields();

        const participantCount = getParticipantCount();
        const playerInputs = playersContainer.querySelectorAll('input[name^="properties[Player "]');
        let isValid = playerInputs.length === participantCount && participantCount > 0;

        if (isTeamTicket && (!teamCountInput || !teamCountInput.value || participantCount < 1)) {
          isValid = false;
        }

        playerInputs.forEach(function (input) {
          if (!input.value.trim()) {
            isValid = false;
          }
        });

        const selectedAgeValue = registration.querySelector('input[name="properties[Any Participants Under 18]"]:checked')?.value;

        if (!selectedAgeValue) {
          isValid = false;
        }

        const activePath = selectedAgeValue === 'Yes' ? juniorPath : selectedAgeValue === 'No' ? adultPath : null;

        if (activePath) {
          activePath.querySelectorAll('input[required]').forEach(function (field) {
            if (!field.checked) {
              isValid = false;
            }
          });
        }

        if (!isValid) {
          event.preventDefault();
          event.stopPropagation();
          showError();
          return false;
        }

        hideError();
        return true;
      }

      registration.addEventListener('input', hideError);
      registration.addEventListener('change', hideError);

      if (teamCountInput) {
        teamCountInput.addEventListener('input', syncPlayerFields);
        teamCountInput.addEventListener('change', syncPlayerFields);
      }

      ageInputs.forEach(function (input) {
        input.addEventListener('change', syncConditionalFields);
      });

      registration.querySelectorAll('[data-mvp-socials-terms-link]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          const popupButtons = Array.from(document.querySelectorAll('.product-popup-modal__button, .mvp-popup-row-button'));
          const participationTermsButton = popupButtons.find(function (button) {
            return button !== link && button.textContent.toLowerCase().includes('participation terms');
          });

          if (participationTermsButton) {
            participationTermsButton.click();
          }
        });
      });

      if (quantityInput) {
        quantityInput.addEventListener('input', syncPlayerFields);
        quantityInput.addEventListener('change', syncPlayerFields);

        const quantityWrapper = quantityInput.closest('quantity-input');
        if (quantityWrapper) {
          quantityWrapper.addEventListener('click', function () {
            window.setTimeout(syncPlayerFields, 0);
          });
        }
      }

      if (productForm) {
        productForm.addEventListener('submit', validateRegistration, true);
      }

      syncPlayerFields();
      syncConditionalFields();
    });
  }

  onReady(function () {
    initParticipationTermsModal();
    initU18Registration();
    initExperienceOtherField();
    initAustralianPhoneFields();
    initSettingPassingClinicRegistration();
    initSocialsRegistration();
  });
})();
